import { createSelector } from '@ngrx/store';
import { ISignatureData } from '@partners/api';
import { IRootState } from '../../../root';
import { ISignatureState } from './signature.state';

export class SignatureSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly signatureState = (state: IRootState): ISignatureState => {
    return state.signature as ISignatureState;
  };

  static readonly model = createSelector(SignatureSelectors.signatureState, (signature: ISignatureState) => {
    return signature.model;
  });

  static readonly data = createSelector(SignatureSelectors.signatureState, (signature: ISignatureState) => {
    return signature.data;
  });

  static readonly formPreviewGroups = createSelector(SignatureSelectors.data, (data: ISignatureData) => {
    return data?.formGroups;
  });
}
